<template>
    <v-simple-table dense>
        <thead>
            <tr>
                <th>CÓD.</th>
                <th>Número Proposta</th>
                <th>Cliente</th>
                <th>JOB</th>
                <th>Contato</th>
                <th>Fone</th>
                <th>Dt.Solicitação</th>
                <th>Prazo</th>
                <th>Vendedor</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="dado in dadosTabela" :key="dado._id">
                <td style="font-size: 10px;">{{ dado?.codigo }}</td>
                <td style="font-size: 10px;">
                    {{ dado?.job?.solicitacaoDeOrcamentoCodigo }}
                </td>
                <td style="font-size: 10px;">
                    {{ dado?.job?.clienteNome }}
                </td>
                <th style="font-size: 10px;">
                    {{ dado.job?.code }}
                </th>
                <td style="font-size: 10px;">{{ dado?.job?.contatoComercial?.celular }}</td>
                <td style="font-size: 10px;">{{ dado?.job?.contatoComercial?.telefone }}</td>
                <th style="font-size: 10px;">{{ new Date(dado.dataSolicitacao).toLocaleDateString() }}</th>
                <td style="font-size: 10px;">{{ new Date(dado.dataEncerramentoPrevista).toLocaleDateString() }}</td>
                <th style="font-size: 10px;">{{ dado?.job?.cliente?.vendedorNome || '' }}</th>
            </tr>
        </tbody>
    </v-simple-table>

</template>

<script>
export default {
    name: 'RelatorioTableView',
    props: ['dadosTabela'],
    data() {
        return {

        }
    }
}
</script>